export default __webpack_public_path__ + "static/fontawesome-webfont-f7f1738ca345185e01856ac55885b089.woff";